import type { ResourceFilterStatus } from '@/lib/api/types/teams';

export const capacityQueryKeys = {
  resources: {
    all: () => ['resources'],
    search: (filters: { query?: string; resourceStatus?: ResourceFilterStatus }) => [
      ...capacityQueryKeys.resources.all(),
      'search',
      filters,
    ],
  },
  workloadSchemes: {
    all: () => ['workloadSchemes'],
    search: (query: string) => [...capacityQueryKeys.workloadSchemes.all(), 'search', query],
  },
  holidaySchemes: {
    all: () => ['holidaySchemes'],
    search: (query: string) => [...capacityQueryKeys.holidaySchemes.all(), 'search', query],
    detail: ({ schemeId }: { schemeId: number }) => [
      ...capacityQueryKeys.holidaySchemes.all(),
      'detail',
      schemeId,
    ],
  },
  locations: {
    all: (activeOnly?: boolean) => ['locations', ...(activeOnly === true ? [{ activeOnly }] : [])],
  },
  teamRoles: {
    all: () => ['team-roles'],
  },
  skills: {
    all: () => ['skills'],
  },
  skillAssignments: {
    all: () => ['skill-assignments'],
    byResourceId: (resourceId: number) => [
      ...capacityQueryKeys.skillAssignments.all(),
      'resource',
      resourceId,
    ],
  },
  common: {
    schemeMembers: {
      all: () => ['scheme-members'],
      detail: (schemeId: number, query?: string) => ['scheme-members', { schemeId, query }],
    },
    membersNotInScheme: {
      all: () => ['members-not-in-scheme'],
      detail: (schemeId: number, query?: string) => ['members-not-in-scheme', { schemeId, query }],
    },
  },
};
